import { render } from "./EditingMediaPodcast.vue?vue&type=template&id=7b184f3a"
import script from "./EditingMediaPodcast.vue?vue&type=script&lang=js"
export * from "./EditingMediaPodcast.vue?vue&type=script&lang=js"
script.render = render

export default script